export const API_HOST = 'https://iows.ikea.com';
export const REDIRECT_URI = 'https://icaps-hantera.ingka.com';
